import BaseModule from "@/components/site-builder/BaseModule";
import ColumnCarousel from "@/components/site-builder/ColumnCarousel";
import ColumnGrid from "@/components/site-builder/ColumnGrid";
import TextField from "@/components/site-builder/TextField";
import { SiteBuilderMultiColumnModuleDisplayType } from "@/constants/site-builder";
import type { SponsorCategoryModuleType } from "./types";
import CategoryLayout from "./CategoryLayout";
import SponsorVariantsMapper from "./SponsorVariantsMapper";
import { getAllSponsors } from "./utils/getAllSponsors";

export interface SponsorCategoryModuleProps {
  module: SponsorCategoryModuleType;
}

export default function SponsorCategoryModule(
  props: SponsorCategoryModuleProps,
) {
  const { module } = props;
  const {
    style: {
      display: {
        displayVariant,
        columnAlignment,
        layoutSize,
        contentLayout,
        displayOrder,
        displayType,
        rotation,
      },
    },
    body: {
      categoryHeaderPosition,
      categoryTitle,
      logo,
      categories,
      disableCardUrl,
    },
  } = module;

  return (
    <BaseModule module={module}>
      {displayType === SiteBuilderMultiColumnModuleDisplayType.Standard &&
        categories.map((category, index) => (
          <CategoryLayout
            key={index}
            header={
              <TextField
                field={{ ...categoryTitle, text: category.title }}
                type="header-h4"
              />
            }
            headerPosition={categoryHeaderPosition}
            columnLayout="3:9"
          >
            <ColumnGrid
              items={category.organisations}
              renderItem={(sponsor) => (
                <SponsorVariantsMapper
                  variant={displayVariant}
                  sponsor={sponsor}
                  logoSettings={logo}
                  disableCardUrl={disableCardUrl}
                />
              )}
              contentLayout={contentLayout}
              columnAlignment={columnAlignment}
              customContentLayout="col-6 col-sm-4"
            />
          </CategoryLayout>
        ))}

      {displayType === SiteBuilderMultiColumnModuleDisplayType.Carousel && (
        <ColumnCarousel
          items={getAllSponsors(categories)}
          renderItem={(sponsor) => (
            <SponsorVariantsMapper
              variant={displayVariant}
              sponsor={sponsor}
              logoSettings={logo}
              disableCardUrl={disableCardUrl}
            />
          )}
          layoutSize={layoutSize}
          contentLayout={contentLayout}
          rotation={rotation}
          displayOrder={displayOrder}
        />
      )}
    </BaseModule>
  );
}
